import { containerless } from "aurelia-framework";
import { LayoutProvider } from "../..";

@containerless
export class VoltoApp {
    constructor(public layoutProvider: LayoutProvider) {
    }
}